import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import NotFound from '../NotFound';

// React 17 has no hook equivalent for componentDidCatch, so this is the one
// class component in the app.
export default class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  state = { hasError: false };

  componentDidCatch(error, errorInfo) {
    // Without this an unhandled render error leaves no trace whatsoever.
    console.error('Unhandled rendering error:', error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <NotFound
          title={t`Something Went Wrong`}
          description={t`This page could not be displayed. Return home and try again.`}
        />
      );
    }

    return children;
  }
}
